import { CompanyUser } from '@/api';

export function isCompanyOwner(user: CompanyUser): boolean {
    return user.role === 'owner';
}

export function isCompanyAdmin(user: CompanyUser): boolean {
    return user.role === 'admin';
}

export function isCompanyBilling(user: CompanyUser): boolean {
    return user.role === 'billing';
}

/** The company-wide "can manage this" role, checked by most permissions. */
export function isCompanyOwnerOrAdmin(user: CompanyUser): boolean {
    return isCompanyOwner(user) || isCompanyAdmin(user);
}
